import { render, staticRenderFns } from "./IPsPage.vue?vue&type=template&id=abb16af2&"
import script from "./IPsPage.vue?vue&type=script&lang=js&"
export * from "./IPsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abb16af2')) {
      api.createRecord('abb16af2', component.options)
    } else {
      api.reload('abb16af2', component.options)
    }
    module.hot.accept("./IPsPage.vue?vue&type=template&id=abb16af2&", function () {
      api.rerender('abb16af2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/IPsPage.vue"
export default component.exports